import {
  REQUEST_PARTNER_LIST_WITH_DETAILS
} from './mutation-types'

export default {
  [REQUEST_PARTNER_LIST_WITH_DETAILS](state, receivedData) {
    state.partnerListWithDetails = receivedData;
  }
}